var axios = require('axios');
var isBrowser = typeof window !== 'undefined';
var port = process.env.PORT;
var devPort = process.env.REACT_APP_PROXY;

var api = (function() {

    var _baseUrl = function() {
        var baseUrl = '';

        if (!isBrowser) {
            baseUrl = 'http://localhost:' + port;
        } else if (process.env.NODE_ENV === 'development') {
            baseUrl = 'http://localhost:' + devPort;
        }
        return baseUrl;
    };

    var _get = function(url, token) {
        var payload = {
            url: _baseUrl() + url,
        };

        if(process.env.NODE_ENV === 'development' && url.includes('adbutler')) {
            payload.url = url;
        }

        if (token) {
            payload.headers = {
                'Authorization': 'Bearer ' + token
            };
        }

        return new Promise(function GETPromise(resolve, reject) {
            axios(payload)
                .then(function(resp) {
                    resolve(resp.data)
                })
                .catch(function(error) {
                    reject(error)
                });
        });
    };

    var _post = function(url, data, token) {
        var payload = {
            method: 'post',
            data: data,
            url: _baseUrl() + url
        };
        if (token) {
            payload.headers = {
                'Authorization': 'Bearer ' + token
            };
        }
        return new Promise(function POSTPromise(resolve, reject) {
            axios(payload)
                .then(function(resp) {
                    resolve(resp.data)
                })
                .catch(function(error) {
                    reject(error)
                });
        });
    };

    var _put = function(url, data, token) {
        var payload = {
            method: 'put',
            data: data,
            url: _baseUrl() + url
        };
        if (token) {
            payload.headers = {
                'Authorization': 'Bearer ' + token
            };
        }

        return new Promise(function PUTPromise(resolve, reject) {
            axios(payload)
                .then(function(resp) {
                    resolve(resp.data)
                })
                .catch(function(error) {
                    reject(error)
                });
        });
    };

    var _patch = function(url, data, token) {
        var payload = {
            method: 'patch',
            data: data,
            url: _baseUrl() + url
        };
        if (token) {
            payload.headers = {
                'Authorization': 'Bearer ' + token
            };
        }

        return new Promise(function PUTPromise(resolve, reject) {
            axios(payload)
                .then(function(resp) {
                    resolve(resp.data)
                })
                .catch(function(error) {
                    reject(error)
                });
        });
    };

    return {
        get: _get,
        post: _post,
        put: _put,
        patch: _patch
    };

})();

module.exports = api;



// WEBPACK FOOTER //
// ./src/common/utils/api.js